import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-family-history",
  templateUrl: "./dental-family-history.component.html",
  styleUrls: ["./dental-family-history.component.scss"],
})
export class DentalFamilyHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
